import { RangeLogicalOption, LogicalOption } from './option.js';

const LogicalFieldMixin = {
  props: {
    logic: {
      type: Object,
      default: function() {
        return {};
      }
    },
    field: {
      type: Object,
      required: true
    },
    controlableFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    possibleFields: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  computed: {
    logicable: function() {
      return this.field.logicable && Boolean(this.controlableFields.length);
    },

    valid: function() {
      return true;
    }
  },

  data: function() {
    return {
      logicSettings: this.logic[this.field.id] || {},
      editing: false
    };
  },

  watch: {
    valid: function(new_value) {
      this.$emit('validChanged', new_value);
    },

    editing: function(new_value) {
      this.$emit('editingChanged', new_value);
    }
  },

  methods: {
    enableEditIfNeed: function() {},

    emitLogicSetting: function() {
      this.$emit('updateSetting', this.logicSettings, this.field);
    },

    isValid: function() {
      return this.valid;
    },

    clearInvalidLogic: function() {}
  }
};

const RangeLogicalFieldMixin = {
  components: {
    'range-logic-option': RangeLogicalOption
  },

  data: function() {
    return {
      logicSettings: this.logic[this.field.id] || [],
      judgements: []
    };
  },

  computed: {
    valid: function() {
      return this.judgements.every((judgement) => judgement.valid);
    }
  },

  methods: {
    enableEditIfNeed: function(event) {
      if (this.editing) {
        return;
      }
      if (!this.logicable) {
        return;
      }
      this.editing = true;
      this._enableBackdrop();
    },

    clearInvalidLogic: function() {
      _.each(this.judgements, (judgement) => {
        judgement._removeInvalidLogic();
      });
    },

    addLogic: function() {
      this.logicSettings.push({
        type: 'range',
        lteq: '',
        field_ids: []
      });
      this.$nextTick(function() {
        return (_.last(this.judgements)).enableEditIfNeed();
      });
    },

    updateLogicSetting: function(setting) {
      this.logicSettings = _.chain(this.judgements)
        .map((judgement) => {
          var result;

          result = judgement.getlogicSetting();
          if (!result) {
            judgement.removeLogic();
          }
          return result;
        })
        .compact()
        .value();
      this.emitLogicSetting();
    },

    removeLogic: function(vm) {
      this.judgements = _.rejectFirst(this.judgements, (child) => child === vm);
      this.logicSettings = _.rejectFirst(this.logicSettings, (_logic) => _logic === vm.logicSetting);
      this.updateLogicSetting();
    },

    addChildFunc: function(vm) {
      this.judgements.push(vm);
    },

    changeEditingStatus: function(new_status) {
      if (new_status) {
        this.editing = new_status;
      } else {
        this.editing = _.some(this.judgements, (judgement) => judgement.editing);
      }
    },

    _enableBackdrop: function() {
      this._backdrop_id = Skylark.Helpers.App.capturedBackdrop((event) => {
        this.editing = false;
        this.updateLogicSetting();
      }, this.$el);
    }
  }
};

export { LogicalFieldMixin, RangeLogicalFieldMixin, LogicalOption };
